import React from 'react';

import { PULSE_KICKSTART_STEPS } from 'constants/ProjectConstants';
import { goToPulseSettingPage } from 'constants/helper';

import ProcessStepper from 'uiToolkit/ProcessStepper';

const allowedStepsForNonPublished = PULSE_KICKSTART_STEPS.slice(3);
const allowedStepsForPublishedSurvey = PULSE_KICKSTART_STEPS.slice(5);

export default function PulseKickstartSteps({
  history,
  currentStep,
  navigateToStep,
  formId,
  instanceName = '',
  maxStepConvered,
  currentStage,
  isDraft = false,
}) {
  return (
    <ProcessStepper
      history={history}
      currentStep={currentStep}
      navigateToStep={navigateToStep}
      formId={formId}
      instanceName={instanceName}
      maxStepConvered={maxStepConvered}
      currentStage={currentStage}
      allowedStepsForNonPublished={isDraft ? [] : allowedStepsForNonPublished}
      allowedStepsForPublished={isDraft ? [] : allowedStepsForPublishedSurvey}
      clickHandler={goToPulseSettingPage}
      steps={PULSE_KICKSTART_STEPS}
      title="New Engagement"
      removeDisplaySuffix
    />
  );
}
